<template>
  <section>
    <overview-table
      title="Detalhamento por Setor"
      :headers="headers"
      :items="items"
      :footers="[footer]"
    >
      <template #[`item.access_rate`]="{ item }">
        <span :class="`text-${accessRateColor(item.access_rate)} font-weight-bold`">{{ Math.round(item.access_rate) }}%</span>
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn
          variant="outlined"
          color="primary"
          size="small"
          @click="emit('select-sector', item.sector_id)"
        >
          Ver detalhes
        </v-btn>
      </template>
      <template #[`footer.access_rate`]="{ value }">
        <span :class="`text-${accessRateColor(Number(value))}`">{{ Math.round(Number(value)) }}%</span>
      </template>
    </overview-table>
  </section>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import OverviewTable from '@/components/events/overview/partials/OverviewTable.vue'
import { accessRateColor } from '@/components/TAccessRateGauge.vue'
import type { AccessControlSector } from '@/types/AccessControl'

interface Props {
  sectors: AccessControlSector[]
}

const props = defineProps<Props>()

const emit = defineEmits<{
  'select-sector': [ sectorId: string ]
}>()

const headers = [
  { key: 'sector_name', value: 'sector_name', title: 'Setor', sortable: false },
  { key: 'generated', value: 'generated', title: 'Emitidos', sortable: false },
  { key: 'read', value: 'read', title: 'Computados', sortable: false },
  { key: 'access_rate', value: 'access_rate', title: 'Taxa de acesso', sortable: false },
  { key: 'actions', value: 'actions', title: 'Ações', sortable: false },
]

const items = computed(() => props.sectors.map(sector => ({
  sector_id: sector.sector_id,
  sector_name: sector.sector_name,
  generated: sector.summary.generated,
  read: sector.summary.read,
  access_rate: sector.summary.access_rate,
})))

const footer = computed(() => {
  const generated = props.sectors.reduce((sum, sector) => sum + sector.summary.generated, 0)
  const read = props.sectors.reduce((sum, sector) => sum + sector.summary.read, 0)

  return {
    sector_name: 'Total geral',
    generated,
    read,
    access_rate: generated > 0 ? (read / generated) * 100 : 0,
    actions: '-',
  }
})
</script>
